module.exports = {"610823001":"横山街道","610823101":"石湾镇","610823102":"高镇","610823103":"武镇","610823104":"党岔镇","610823105":"响水镇","610823106":"波罗镇","610823107":"殿市镇","610823108":"塔湾镇","610823109":"赵石畔镇","610823110":"魏家楼镇","610823111":"韩岔镇","610823112":"白界镇","610823113":"雷龙湾镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610823.json
// module id = 2863
// module chunks = 0